import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils/types";

export const CalendarIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      className={twMerge("size-5", className)}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 7.5H15.75M6.75 3.75H4.65C3.80992 3.75 3.38988 3.75 3.06901 3.91349C2.78677 4.0573 2.5573 4.28677 2.41349 4.56901C2.25 4.88988 2.25 5.30992 2.25 6.15V13.35C2.25 14.1901 2.25 14.6101 2.41349 14.931C2.5573 15.2132 2.78677 15.4427 3.06901 15.5865C3.38988 15.75 3.80992 15.75 4.65 15.75H13.35C14.1901 15.75 14.6101 15.75 14.931 15.5865C15.2132 15.4427 15.4427 15.2132 15.5865 14.931C15.75 14.6101 15.75 14.1901 15.75 13.35V6.15C15.75 5.30992 15.75 4.88988 15.5865 4.56901C15.4427 4.28677 15.2132 4.0573 14.931 3.91349C14.6101 3.75 14.1901 3.75 13.35 3.75H11.25M6.75 3.75H11.25M6.75 3.75V3.375C6.75 2.75368 6.24632 2.25 5.625 2.25C5.00368 2.25 4.5 2.75368 4.5 3.375V3.75M11.25 3.75V3.375C11.25 2.75368 11.7537 2.25 12.375 2.25C12.9963 2.25 13.5 2.75368 13.5 3.375V3.75"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
      />
    </svg>
  );
};
